module.exports = __webpack_public_path__ + "img/logo-ifm-square-512.1bd04239.png";